import ExpansionPanel from './ExpansionPanel.vue'
import ExpansionPanelContent from './ExpansionPanelContent.vue'

export default {
  ExpansionPanel,
  ExpansionPanelContent
}



// WEBPACK FOOTER //
// ./src/components/expansion-panel/index.js